"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.request = void 0;
const effects_1 = require("redux-saga/effects");
const state_1 = require("../state");
function* request(actionCreator, load) {
    yield (0, effects_1.put)(actionCreator({ result: (0, state_1.createLoadingResult)() }));
    try {
        const data = (yield (0, effects_1.call)(load));
        const result = (0, state_1.createDataResult)(data);
        yield (0, effects_1.put)(actionCreator({ result }));
        return result;
    }
    catch (error) {
        const result = (0, state_1.createErrorResult)(error);
        yield (0, effects_1.put)(actionCreator({ result }));
        return result;
    }
}
exports.request = request;
//# sourceMappingURL=util.js.map